import React from 'react'
import { generatePath, NavLink } from 'react-router-dom'

import { Nav, Navbar } from 'rsuite'
import { PhonePortraitOutline, StorefrontOutline, ArchiveOutline, StarOutline } from 'react-ionicons'

import { usePartner } from '@@partner:helpers/hooks/auth'

import { ROUTE_DEVICES, ROUTE_SHOP_TAGS, ROUTE_SHOPS, ROUTE_SHOPS_FEEDBACKS, ROUTE_STORAGE_CONTAINERS } from '@@partner:config/routes'

export default function ShopTopMenu () {
  const { brandSlug } = usePartner()
  
  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<StorefrontOutline />}
          as={NavLink}
          to={generatePath(ROUTE_SHOPS, { brandSlug })}
        >Магазины</Nav.Item>
        <Nav.Item
          icon={<StorefrontOutline />}
          as={NavLink}
          to={generatePath(ROUTE_SHOP_TAGS, { brandSlug })}
        >Сервисы в магазине</Nav.Item>
        <Nav.Item
          icon={<PhonePortraitOutline />}
          as={NavLink}
          to={generatePath(ROUTE_DEVICES, { brandSlug })}
        >Устройства</Nav.Item>
        <Nav.Item
          icon={<ArchiveOutline />}
          as={NavLink}
          to={generatePath(ROUTE_STORAGE_CONTAINERS, { brandSlug })}
        >Контейнеры</Nav.Item>
        <Nav.Item
          icon={<StarOutline />}
          as={NavLink}
          to={generatePath(ROUTE_SHOPS_FEEDBACKS, { brandSlug })}
        >Отзывы</Nav.Item>
      </Nav>
    </Navbar>
  )
}